import { render, staticRenderFns } from "./FormElement.vue?vue&type=template&id=71253b2e&"
import script from "./FormElement.vue?vue&type=script&lang=js&"
export * from "./FormElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
installComponents(component, {VCheckbox,VRadio})
